
import store from '@/store/index.js'
import { sendErrorLog } from '@/utils/common.js'
const _ = require('lodash')
import { getNodeList, saveOneNode, saveNodeList } from '@/utils/appcache.js'
import {
    getMasternodePing,
    getPrivateKey,
    signMasternode,
    broadcastMasternode,
    getMasternodeStatus,
    deleteMasterNode
} from '@/wallet/walletUtil'
import { userNodes, getNode } from '@/service/http.js'


/**
 * 根据接收地址返回对应节点IP
 */
 export function loadIpWithAddress(address) {
   return new Promise((resolve, reject) => {
      getNodeList().then(arr => {
        const x = _.find(arr, i => {
          return i.nodeset && i.nodeset.address == address
        })
        if (x) return resolve(x.ip)
        return reject(null)
      })
   })

}


/**
 * 查询冻结的链分数量
 */
export function coldingAmount() {
    let freezeAmount = 1000
    if(process.env.freeze_amount) {
      freezeAmount = process.env.freeze_amount
    }
    return new Promise((resolve, reject) => {
        getNodeList().then(arr => {
            if (!arr) return resolve(0)
            var amount = 0
            arr.forEach(element => {
                if (element.nodeset) {
                    amount = amount + Number(freezeAmount)
                }
            })
            return resolve(amount)
        }).catch(e => {
            sendErrorLog('[nodeutl.js-getNodeList]' + e)
            return reject(e)
        })
    })
}

/**
 * 拉取服务器节点列表
 */
export function checkServerNodes() {
    return new Promise((resolve, reject) => {
        userNodes({ uid: store.state.user.id }).then(res => {
            if (res.code === 200) {
                const sarr = res.data || []
                if (!sarr) {
                    saveNodeList([])
                    resolve(true)
                }
                getNodeList().then(arr => {
                    if (!(arr instanceof Array)) {
                        arr = []
                    }
                    for (let i = 0; i < sarr.length; i++) {
                        let element = sarr[i]
                        element.ip = element.ip + ':' + process.env.chain_port

                        const ishave = _.find(arr, x => {
                            return x.ip == element.ip
                        })
                        if (!ishave) {
                            arr.push(element)
                        }
                    }
                    for (let i = 0; i < arr.length; i++) {
                      let element = arr[i]
                      const ishave = _.find(sarr, x => {
                          return x.ip.split(':')[0] == element.ip.split(':')[0]
                      })
                      if (!ishave) {
                          arr.splice(i,1)
                      } else {
                        element.maturityTime = ishave.maturityTime
                      }
                    }
                    saveNodeList(arr)
                    resolve(true)
                })
            } else {
                reject(res.pagePrompt)
            }
        })
    })
}

/**
 * 更新节点运行zbx状态
 */
export async function updateNodeStatus() {
    var arr = await getNodeList()
    if (!arr) return
    for (let index = 0; index < arr.length; index++) {
        const node = arr[index]
        if (!node) {
            continue
        }
        try {
            var nodeip = node.ip
            if (nodeip.indexOf(':') > 0) {
                nodeip = nodeip.split(':')[0]
            }
            const s = await getNode(nodeip)
            if (s) {
                console.log('节点状态：', s)
                node.chainstatus = s
                await saveOneNode(node)
            }
        } catch (error) {
            console.log(error)
            sendErrorLog('[nodeutl.js-updateNodeStatus]' + error)
        }
    }
}

/**
 * 更新节点实时状态
 */
export async function updateNodeStatuSync() {
    var arr = await getNodeList()
    if (!arr) return
    for (let index = 0; index < arr.length; index++) {
        const node = arr[index]
        if (!node) {
            continue
        }
        try {
            const s = await getMasternodeStatus(node.ip)
            node.chainstatus = s
            await saveOneNode(node)
        } catch (error) {
            console.log(error)
            const errStr = error.toString()
            if(errStr.indexOf('Could not get height from block explorer') < 0) {
              node.chainstatus = null
            }
            sendErrorLog('[nodeutl.js-updateNodeStatuSync]' + error)
            await saveOneNode(node)
        }
    }
}

/**
   * 激活节点
   */
export function activeNode(param) {
    return new Promise((resolve, reject) => {
        getMasternodePing(param.utxo.txid, param.utxo.vout)
            .then(pingRet => {
                const signPrivKey = getPrivateKey(param.utxo.path)
                pingRet.privKey = param.node.genkey
                pingRet.ip = param.node.ip
                pingRet.signPrivKey = signPrivKey
                signMasternode(pingRet)
                    .then(signRet => {
                        console.log(signRet)
                        broadcastMasternode(signRet, signPrivKey)
                            .then(() => {
                                param.node.nodeset = param.utxo
                                saveOneNode(param.node).then(() => {
                                    return resolve(true)
                                }).catch(e => {
                                    return reject(e)
                                })
                            })
                            .catch(e => {
                              sendErrorLog('[nodeutl.js-broadcastMasternode]' + e)
                              return reject(e)
                            })
                    })
                    .catch(e => {
                      sendErrorLog('[nodeutl.js-signMasternode]' + e)
                        return reject(e)
                    })
            })
            .catch(e => {
              sendErrorLog('[nodeutl.js-getMasternodePing]' + e)
              return reject(e)
            })
    })
}

/**
 * 删除节点配置
 * @param {*} txid
 */
export function removeOnlineNode(txid) {
    return new Promise((resolve, reject) => {
        deleteMasterNode(txid).then(() => {
            return resolve()
        }).catch(e => {
          sendErrorLog('[nodeutl.js-deleteMasterNode]' + e)
          return reject(e)
        })
    })
}



// WEBPACK FOOTER //
// ./src/store/nodeutl.js